import { useAppSelector } from '../redux/storeConfig/store'
import { selectFeatureFlagEnabled } from '../redux/storeConfig/slices/slice.featureFlags'

/**
 * Convenience hook that reads a feature flag's enabled state from the Redux store.
 *
 * Returns `true` when the flag identified by `key` is enabled in the store,
 * and `false` when it is disabled or absent. Does NOT dispatch any network
 * request — callers are responsible for ensuring the flag has already been
 * fetched (e.g. via `FeatureFlaggedRoute` or a prior `checkFeatureFlag` dispatch).
 */
export function useFeatureFlag(key: string): boolean {
  return useAppSelector((state) => selectFeatureFlagEnabled(state, key))
}

export default useFeatureFlag
